// 收付款 关联 订单金额
<template>
  <div class="clearfix">
    <div class="modal-header sel-modal-header clearfix">
      <vxe-radio-group v-model="cate" size="medium">
        <ul class="tab-list">
          <li v-if="cate == 'Payment'">
            <vxe-radio name="xtabs" label="Payment">承运人订单</vxe-radio>
          </li>
          <li v-if="cate == 'SellerPayment'">
            <vxe-radio name="xtabs" label="SellerPayment"
              >实际供应方订单</vxe-radio
            >
          </li>
        </ul>
      </vxe-radio-group>
      <div class="my-search">
        <vxe-input
          v-model="searchOrdersNum"
          style="width: 200px"
          type="search"
          placeholder="输入订单号"
          @search-click="search"
          @keyup.enter.native="search"
        ></vxe-input>
        <vxe-input
          v-model="searchOrdersName"
          type="search"
          :placeholder="
            cate === 'Collection'
              ? '请输入托运人名称'
              : cate === 'Payment'
              ? '请输入承运人名称'
              : '请输入实际承运人名称'
          "
          @search-click="search"
          @keyup.enter.native="search"
          style="width: 200px; margin-left: 20px"
        ></vxe-input>
      </div>
    </div>

    <div class="add-box clearfix">
      <vxe-table
        show-overflow
        stripe
        highlight-current-row
        border="none"
        class="table-style"
        ref="xTable"
        max-height="450"
        :auto-resize="true"
        :data="tableData"
        @current-change="currentChangeEvent"
      >
        <vxe-table-column
          field="ordersNumb"
          title="子订单编号"
          width="130"
        ></vxe-table-column>
        <vxe-table-column field="contractTitle" title="订单标题" width="120"></vxe-table-column>
        <vxe-table-column
          field="buyerName"
          title="托运人名称"
          width="200"
        ></vxe-table-column>
        <vxe-table-column
          field="sellerName"
          title="承运人名称"
          width="200"
        ></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="105">
          <template slot-scope="{ row, $rowIndex }">
            <div style="height: 24px">
              <div v-if="row.goodsRtnVos">{{ row.goodsName }}</div>
              <Icon
                type="ios-arrow-down"
                @click.stop="toggleGoods($rowIndex)"
                v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
              />
              <vxe-pulldown :ref="$rowIndex" placement="bottom" transfer>
                <template v-slot:dropdown>
                  <div class="my-dropdown3">
                    <vxe-table
                      auto-resize
                      :data="row.goodsRtnVos"
                      stripe
                      show-overflow
                      max-height="480"
                      align="center"
                    >
                      <vxe-table-column
                        field="goodsName"
                        title="货名"
                        width="104"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="unit"
                        title="单位"
                        width="75"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="counts"
                        title="数量"
                        width="75"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="price"
                        title="单价"
                        width="75"
                      ></vxe-table-column>
                      <vxe-table-column field="isTax" title="含税" width="75">
                        <template slot-scope="{ row }">
                          <span>{{ row.isTax | taxMap }}</span>
                        </template>
                      </vxe-table-column>
                      <vxe-table-column
                        field="carShipNum"
                        title="车船号"
                        width="90"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="beginPlace"
                        title="起运地"
                        width="90"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="endPlace"
                        title="到达地"
                        width="90"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="beginTime"
                        title="受载/起运时间"
                        width="140"
                      >
                        <template slot-scope="{ row }">
                          <span>{{ row.beginTime | timeFormatDate }}</span>
                        </template>
                      </vxe-table-column>
                    </vxe-table>
                  </div>
                </template>
              </vxe-pulldown>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="rule"
          title="规格"
          width="75"
        ></vxe-table-column>
        <vxe-table-column
          field="unit"
          title="单位"
          width="75"
        ></vxe-table-column>
        <vxe-table-column
          field="counts"
          title="数量"
          width="75"
        ></vxe-table-column>
        <vxe-table-column
          field="price"
          title="单价"
          width="75"
        ></vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="75">
          <template slot-scope="{ row }">
            <span>{{ row.isTax | taxMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="carShipNum"
          title="车船号"
          width="80"
        ></vxe-table-column>
        <vxe-table-column
          field="beginPlace"
          title="起运地"
          width="100"
        ></vxe-table-column>
        <vxe-table-column
          field="endPlace"
          title="到达地"
          width="100"
        ></vxe-table-column>
        <vxe-table-column field="beginTime" title="起运日期" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createUser"
          title="创建人"
          width="100"
        ></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div>
      <vxe-pager
        style="margin-top: 20px"
        background
        size="small"
        :current-page.sync="page.currentPage"
        :page-size.sync="page.pageSize"
        :total="page.totalResult"
        @page-change="changePage"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import { isEmpty, isNotEmpty } from "@/utils/util";
import { numberToCurrency, numberToMoney } from "@/filters/type";
export default {
  name: "PaymentAboutOrder",
  props: {
    chainId: Number
  },
  data() {
    return {
      cate: "", // 选择的订单类型,  Collection 购买方订单  Payment SellerPayment 承运人订单
      platformCompanyId: "", //所属平台
      searchOrdersNum: "", //搜索订单号
      searchOrdersName: "", //搜索托运人 或 承运人 实际承运人 名称
      loading: false,
      payAmount: 0,
      tableData: [],
      isCheckboxAll: false,
      checkboxConfig: {
        labelField: "操作",
        checkField: "checked",
      },
      currentPage: 0,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      resMoneyMap: {},
    };
  },
  methods: {
    init(cate, paymentsId, payAmount, ordersList, platformCompanyId) {
      this.page.currentPage = 1;
      this.isCheckboxAll = false;
      this.cate = cate;
      this.platformCompanyId = platformCompanyId;
      this.paymentsId = isEmpty(paymentsId) ? 0 : paymentsId;
      this.payAmount = payAmount;
      this.ordersList = isEmpty(ordersList) ? [] : ordersList;

      this.searchOrdersNum = "";
      this.searchOrdersName = "";

      this.resMoneyMap = {};
      this.ordersList.forEach((item) => {
        if (isNotEmpty(item.ordersId)) {
          item.checked = true;
          this.resMoneyMap[item.ordersId] = item;
        }
      });

      this.getOrderList();
    },
    changePage(e) {
      this.page.pageSize = e.pageSize;
      if (this.currentPage != e.currentPage) {
        this.currentPage = e.currentPage;
        this.getOrderList();
      }
    },
    search() {
      this.page.currentPage = 1;
      this.getOrderList();
    },
    async getOrderList() {
      // 获取列表数据
      this.loading = true;
      let params = {
        paymentsId: this.paymentsId,
        platformCompanyId: this.platformCompanyId,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2,
        chainId: this.chainId
      };
      //搜索的参数
      if (this.searchOrdersNum) {
        if (this.cate == "Collection") {
          params.buyerOrdersNum = this.searchOrdersNum;
        } else {
          params.sellerOrdersNum = this.searchOrdersNum;
        }
      }
      if (this.searchOrdersName) {
        if (this.cate == "Collection") {
          params.buyerName = this.searchOrdersName;
        } else {
          params.sellerName = this.searchOrdersName;
        }
      }
      let res;
      if (this.cate == "Collection") {
        res = await $api.order.post("queryOrdersBuyerRelatedMoneyList", params);
      } else {
        params.isRealSeller = this.cate == "Payment" ? 0 : 1;
        res = await $api.sellerOrder.post(
          "queryOrdersSellerRelatedMoneyList",
          params
        );
      }

      if (res.status != 1) {
        if (isEmpty(res.message)) res.message = "接口异常";
        this.$refs.$XModal.message(res.mesage);
        return;
      }

      let tableData = res.data.rows;
      this.isCheckboxAll = true;
      tableData.map((i) => {
        if (this.cate == "Collection") {
          i.ordersNumb = i.buyerOrdersNum;
        } else {
          i.ordersNumb = i.sellerOrdersNum;
        }

        if (
          isNotEmpty(this.resMoneyMap[i.id]) &&
          this.resMoneyMap[i.id].aboutAmount > 0
        ) {
          i.relatedAmount = this.resMoneyMap[i.id].aboutAmount;
          i.aboutAmount = i.relatedAmount;
        } else {
          i.aboutAmount = null;
        }

        if (isEmpty(i.aboutAmount)) {
          i.checked = false;
          this.isCheckboxAll = false;
        } else {
          i.checked = true;
        }

        if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
          i.goodsName = i.goodsRtnVos[0].goodsName;
          i.rule = i.goodsRtnVos[0].rule;
          i.unit = i.goodsRtnVos[0].unit;
          i.counts = i.goodsRtnVos[0].counts;
          i.price = i.goodsRtnVos[0].price;
          i.isTax = i.goodsRtnVos[0].isTax;
          i.carShipNum = i.goodsRtnVos[0].carShipNum;
          i.beginPlace = i.goodsRtnVos[0].beginPlace;
          i.endPlace = i.goodsRtnVos[0].endPlace;
          i.beginTime = i.goodsRtnVos[0].beginTime;
          i.createTime = i.goodsRtnVos[0].createTime;
        }
      });
      this.tableData = tableData;
      this.page.totalResult = res.data.total;

      if (isNotEmpty(this.$refs.xTable)) {
        tableData.forEach((row) => {
          if (row.checked == true) {
            this.$refs.xTable.setCheckboxRow(row, true);
          }
        });
      }
      this.loading = false;
    },
    cellClick(e) {},
    checkboxChange({ row }) {
      row.checked = row.checked == true ? false : true;
      if (row.checked == false && isNotEmpty(this.resMoneyMap[row.id])) {
        delete this.resMoneyMap[row.id];
      }
      if (row.checked === false) {
        this.isCheckboxAll = false;
      }
    },
    checkBoxAll(e) {
      this.isCheckboxAll = this.isCheckboxAll == true ? false : true;
      this.tableData.forEach((item) => (item.checked = this.isCheckboxAll));
      if (this.isCheckboxAll == false) {
        this.tableData.forEach((item) => {
          item.aboutAmount = null;
          if (isNotEmpty(this.resMoneyMap[item.id])) {
            delete this.resMoneyMap[item.id];
          }
        });
      }
      this.$refs.xTable.updateStatus();
    },
    inputAboutAmount(row) {
      row.checked = true;
      this.resMoneyMap[row.id] = row;
    },
    toggleGoods(id) {
      this.$refs[id].togglePanel();
    },
    currentChangeEvent({ row }) {
      let resAmountList = [];
      let usedAmount = 0;
      let paymentType;
      if (this.cate == "Collection") {
        paymentType = 1;
      } else if (this.cate == "Payment") {
        paymentType = 2;
      } else {
        paymentType = 3;
      }
      let obj = {
        id: row.id,
        ordersId: row.id,
        ordersNumb: row.ordersNumb,
        chainNum: row.chainNum,
        buyerName: row.buyerName,
        buyerId: row.buyerId,
        sellerName: row.sellerName,
        sellerId: row.sellerId,
        salesMan: row.salesMan,
        salesManName: row.salesManName,
        rateManage: row.rateManage,
        platformCompany: row.platformCompany,
        platformCompanyId: row.platformCompanyId,
        paymentType,
      };
      resAmountList.push(obj);

      this.$emit("choose", resAmountList, usedAmount);
    },
  },
};
</script>

<style scoped>
.vxe-pager .vxe-pager--wrapper {
  position: relative;
}

.vxe-pager .vxe-pager--sizes {
  height: 28px !important;
}

.modal-header {
  position: relative;
  height: 60px;
}

.my-search {
  padding: 10px;
  position: absolute;
  right: 0;
  top: 0;
}

.my-search .vxe-input {
  height: 34px;
  width: 400px;
}

.my-search .vxe-input >>> .vxe-input--suffix {
  display: block !important;
  width: 60px;
  height: 32px;
  top: 1px;
  text-align: center;
  border-left: 1px solid #dcdfe6;
  background-color: #f5f7fa;
  cursor: pointer;
}

.my-search .vxe-input >>> .vxe-input--inner {
  border: 1px solid #dcdfe6;
}

.btn-down {
  border: none;
  background: transparent;
}

.btn-down:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
}

.link-text {
  margin-right: 30px;
  margin-left: 10px;
}

.ivu-btn.ivu-btn-primary {
  width: 140px;
  height: 40px;
}
</style>